module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box citic-box"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('el-autocomplete', {
    staticClass: "search",
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "按类别搜",
      "type": "text"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.keywords1),
      callback: function($$v) {
        _vm.keywords1 = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "keywords1"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('el-autocomplete', {
    staticClass: "search",
    attrs: {
      "fetch-suggestions": _vm.querySearch2,
      "placeholder": "按全称搜",
      "type": "text"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.keywords2),
      callback: function($$v) {
        _vm.keywords2 = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "keywords2"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('el-autocomplete', {
    staticClass: "search",
    attrs: {
      "fetch-suggestions": _vm.querySearch3,
      "placeholder": "按简称搜",
      "type": "text"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.keywords3),
      callback: function($$v) {
        _vm.keywords3 = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "keywords3"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('el-button', {
    staticClass: "btn-search",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn-search",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("删除")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "产品管理",
      "name": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleEdit()
      }
    }
  }, [_vm._v("增加新产品")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.productData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "product_name",
      "label": "产品名称",
      "width": "200",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "category_name",
      "label": "类别标签",
      "width": "200",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "厂商全称",
      "width": "150",
      "prop": "factoryqc_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "factory_name",
      "label": "厂商简称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row.id)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.row.id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list__footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.page_size,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-c35bc640!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/product/product.vue
// module id = 479
// module chunks = 11